// Google Search Console verification is now a STATIC meta tag in public/index.html
// (Google reads the raw HTML, so it must be present pre-JS). This component is kept
// as a no-op to avoid a duplicate tag; all script-based tracking lives in lib/analytics.js.
export const Analytics = () => null;
